import { safeLocalStorage } from '@zealot/shared';
import { brandHintFromUrl } from '@/lib/appBootstrap/brandHintFromUrl';
import type { BrandTheme } from './brandTheme';
import type { HubBrand } from './hubBrand';

export const HUB_BRAND_STORAGE_KEY = 'advocate-portal-hub';

export const emptyHubBrand: HubBrand = {
  uuid: undefined,
  brandID: undefined,
  code: undefined,
  brandName: undefined,
  hubLabel: undefined,
};

// gloss
export const pickHubIdentity = (hub: HubBrand): HubBrand => ({
  uuid: hub.uuid,
  brandID: hub.brandID,
  code: hub.code,
  brandName: hub.brandName,
  hubLabel: hub.hubLabel,
});

// gloss
const fromLegacyKeys = (): HubBrand => ({
  uuid: safeLocalStorage.getItem('brandUuid') ?? undefined,
  brandID: safeLocalStorage.getItem('brandID') ?? undefined,
  code: safeLocalStorage.getItem('code') ?? undefined,
  brandName: safeLocalStorage.getItem('brand') ?? undefined,
  hubLabel: safeLocalStorage.getItem('hubLabel') ?? undefined,
});

// gloss
export const brandThemeFromLegacyKeys = (): BrandTheme => ({
  icon: safeLocalStorage.getItem('brandIcon') ?? undefined,
  loaderGIFURL: safeLocalStorage.getItem('loaderGifUrl') ?? undefined,
  primaryColor: safeLocalStorage.getItem('primaryColor') ?? undefined,
  colorBrandLogo: safeLocalStorage.getItem('colorBrandLogo') ?? undefined,
  whiteBrandLogo: safeLocalStorage.getItem('whiteBrandLogo') ?? undefined,
  loginBackground: safeLocalStorage.getItem('loginBackground') ?? undefined,
  linkColor: safeLocalStorage.getItem('linkColor') ?? undefined,
  programTitle: safeLocalStorage.getItem('programTitle') ?? undefined,
});

// gloss
export const addressNamesStoredHub = (hub: HubBrand): boolean => {
  const url = new URL(window.location.href);

  const requestedUuid = url.searchParams.get('brandUuid');
  if (requestedUuid) return !hub.uuid || hub.uuid === requestedUuid;

  const hint = brandHintFromUrl({ url, hostname: window.location.hostname });

  return hint ? hub.hubLabel === hint : true;
};

// gloss
export const mergeHubBrand = (persisted: HubBrand | undefined): HubBrand => {
  if (typeof window === 'undefined') return emptyHubBrand;

  const stored = persisted ? persisted : fromLegacyKeys();

  return addressNamesStoredHub(stored) ? pickHubIdentity(stored) : emptyHubBrand;
};
